export interface TelemetryEvent {
	type:
		| EventType
		| AppsEventType
		| DesktopEventType
		| GeneralEventType
		| BrowserExtensionEventType
		| ShieldHealthCheckEventType
		| BrowserExtensionInstallPromptEventType
		| MandateNativeAppEventType
		| MandateSaasLaunchInCEBEventType
		| ShieldSupportabilityEventType
		| string;
}

export enum EventSite {
	Tile = 'Tile',
	Recent = 'QuickAccess',
	MoreInfo = 'MoreInfo',
	ActitivityManager = 'ActivityManager',
	Search = 'Search',
}

export enum EventFilter {
	Favourite = 'favourite',
	Categories = 'categories',
}

export enum AppsEventType {
	Launch = 'Apps.launch',
	Launch_Failure = 'Apps.launch.failure',
	Favourite = 'Apps.favourite',
	MoreInfo = 'Apps.moreInfo',
	Filtering = 'Apps.filtering',
	Sorting = 'Apps.sorting',
	Install = 'Apps.install',
	Update = 'Apps.update',
	Remove = 'Apps.remove',
	DoesNotExist = 'Apps.doesnotexist',
	Troubleshoot = 'Apps.troubleshoot',
}

export enum DesktopEventType {
	Launch = 'Desktop.launch',
	Favourite = 'Desktop.favourite',
	MoreInfo = 'Desktop.moreInfo',
	Filtering = 'Desktop.filtering',
	Sorting = 'Desktop.sorting',
	Restart = 'Desktop.restart',
	DoesNotExist = 'Desktops.doesnotexist',
	Troubleshoot = 'Desktops.troubleshoot',
}

export enum TroubleshootEventType {
	CopyDetails = 'Troubleshoot.copyDetails',
	DownloadLogs = 'Troubleshoot.downloadLogs',
	CloseOnError = 'Troubleshoot.closeOnError',
	GetLogs = 'Troubleshoot.getLogs',
	FixIssue = 'Troubleshoot.fixIssue',
}

export enum GeneralEventType {
	EditProfile = 'EditProfile.change',
	RegionalSettings = 'RegionalSettings.change',
	ScreenSwitch = 'Screen.switch',
}

export enum BrowserExtensionEventType {
	BrowserExtensionAppLaunch = 'BrowserExtensionAppLaunch',
	BrowserExtensionAppLaunchError = 'BrowserExtensionAppLaunch_Error',
	BrowserExtensionIcaLaunch = 'BrowserExtensionIcaLaunch',
	BrowserExtensionLeaseLaunch = 'BrowserExtensionLeaseLaunch',
	BrowserExtensionLeaseLaunchLeaseFallbackToIca = 'BrowserExtensionLeaseLaunch_LeaseFallbackToIca',
	BrowserExtensionLeaseLaunchIcaFallbackToLease = 'BrowserExtensionLeaseLaunch_IcaFallbackToLease',
	BrowserExtensionLeaseLaunchCloudOffline = 'BrowserExtensionLeaseLaunch_CloudOffline',
	BrowserExtensionCloudOfflineGetUserDetailsFailed = 'CloudOfflineWithExtension_GetUserDetailsFailed',
	BrowserExtensionCloudOfflineUserTriggered = 'CloudOfflineWithExtension_UserTriggered',
}

export enum BrowserExtensionInstallPromptEventType {
	InstallPromptInstalled = 'BrowserExtensionInstallPrompt.Installed',
	InstallPromptCancelled = 'BrowserExtensionInstallPrompt.Cancelled',
}

export enum ShieldHealthCheckEventType {
	Success = 'ShieldHealthCheck.success',
	Retry = 'ShieldHealthCheck.retry',
	Unauthenticated = 'ShieldHealthCheck.unauthenticated',
	ClSyncSuccess = 'Shield.clsync_pass',
	ClSyncFail = 'Shield.clsync_fail',
	CLMLaunchStart = 'Shield.clm_launch_start',
	CLMLaunchMiniIcaGenerated = 'Shield.clm_launch_mini_ica_generated',
	CLMLaunchFinalIcaGenerated = 'Shield.clm_launch_final_ica_generated',
	CLMLaunchHandleVSRResult = 'Shield.clm_launch_handle_vsr_result',
	CLMLaunchError = 'Shield.clm_launch_error',
	HeartBeat = 'ServiceContinuity.HeartBeat',
}

export enum CustomizeUserHomeModalEventType {
	Subscription_Success = 'CustomizeUserHomeModal.subscription.success',
	Subscription_Failure = 'CustomizeUserHomeModal.subscription.failure',
	Skipped_Personalization = 'CustomizeUserHomeModal.skipped.personalization',
	Shortcut_Success = 'CustomizeUserHomeModal.shortcut.success',
	Shortcut_Failure = 'CustomizeUserHomeModal.shortcut.failure',
	Skipped_Shortcut = 'CustomizeUserHomeModal.skipped.shortcut',
}

export enum EventType {
	NotificationFeed_SortOrderChange = 'NotificationFeed.SortOrderChange',
	NotificationFeed_PageLoad = 'NotificationFeed.PageLoad',
	NotificationFeed_LoadNewFeedCards = 'NotificationFeed.LoadNewFeedCards',
	NotificationFeed_ScrollLoad = 'NotificationFeed.ScrollLoad',
	Activity = 'ACTIVITY',
	Start = 'start',
	End = 'end',
	Error = 'error',
	Fix = 'fix',
	Cancel = 'cancel',
	WorkspaceToStorefrontFallback = 'WorkspaceToStorefrontFallback',
	Search_Init = 'Search.init',
	Search_KeyIn = 'Search.keyin',
	Search_Select = 'Search.select',
	Search_No_Results = 'Search.noResults',
	AdminNotificationBanner = 'AdminNotificationBanner',
	DevicePostureBanner = 'NonComplaintDeviceBanner',
	CitrixEnterpriseBrowser_Launch = 'CitrixEnterpriseBrowser.Launch',
	CitrixEnterpriseBrowser_ResourceAvailable = 'CitrixEnterpriseBrowser.ResourceAvailable',
	SaasLaunch_UsingNative = 'SaasLaunch.UsingNative',
}

export enum ActivityManagerEventType {
	ActivityManager_Init = 'ActivityManager.Init',
	ActivityManager_Logout = 'ActivityManager.Logout',
	ActivityManage_Disconnect = 'ActivityManager.Disconnect',
	ActivityManager_Restart = 'ActivityManager.Restart',
	ActivityManager_ControlledRestart = 'ActivityManager.ControlledRestart',
	ActivityManager_Terminate = 'ActivityManger.Terminate',
	ActivityManager_Poweroff = 'ActivityManager.Poweroff',
	ActivityManager_Shutdown = 'ActivityManager.Shutdown',
	ActivityManager_Hibernate = 'ActivityManager.Hibernate',
	ActivityManager_Resume = 'ActivityManager.Resume',
	ActivityManager_Reconnect = 'ActivityManager.Reconnect',
	ActivityManager_Transfer = 'ActivityManager.Transfer',
}

export enum ConfiguredServiceEventType {
	ConfiguredService_HomeTabEnabled = 'ConfiguredService.HomeTabEnabled',
	ConfiguredService_HomeTabDisabled = 'ConfiguredService.HomeTabDisabled',
	ConfiguredService_SimpleViewEnabled = 'ConfiguredService.SimpleViewEnabled',
	ConfiguredService_SimpleViewDisabled = 'ConfiguredService.SimpleViewDisabled',
}

export enum AADSsoEventType {
	TokenRequested = 'AADSsoEvent.AuthTokenRequested',
	TokenError = 'AADSsoEvent.AuthTokenError',
}

export enum GACSV2EventType {
	GACSV2Enabled = 'GACSV2Event.GACSV2Enabled',
	GACSV2IsSuccess = 'GACSV2Event.GACSV2IsSuccess',
	GACSV2Latency = 'GACSV2Event.GACSV2Latency',
	GACSV2Timeout = 'GACSV2Event.GACSV2Timeout',
}

export enum PinnedLinksEventType {
	pinnedLinkDetails = 'PinnedLinks.PinnedLinkDetails',
	pinnedLinkClicked = 'PinnedLinks.PinnedLinkClicked',
}

export enum MandateNativeAppEventType {
	ScreenLoaded = 'MandateNativeApp.ScreenLoaded',
	OpenCitrixWorkspaceClicked = 'MandateNativeApp.OpenCitrixWorkspaceClicked',
	DownloadWorkspaceLinkClicked = 'MandateNativeApp.DownloadWorkspaceLinkClicked',
	StoreUrlCopied = 'MandateNativeApp.StoreUrlCopied',
	UserGuideOpened = 'MandateNativeApp.UserGuideOpened',
}

export enum MandateSaasLaunchInCEBEventType {
	PromptDisplayed = 'MandateSaasLaunchInCEB.PromptDisplayed',
	CebDownloadClicked = 'MandateSaasLaunchInCEB.CebDownloadClicked',
	UserGuideOpened = 'MandateSaasLaunchInCEB.UserGuideOpened',
	FallBackToOpenInNewTab = 'MandateSaasLaunchInCEB.FallBackToOpenInNewTab',
	LaunchUsingCEB = 'MandateSaasLaunchInCEB.LaunchUsingCEB',
}
export interface TelemetryEventPublisher {
	publishEvent: <T extends TelemetryEvent>(event: T) => Promise<void>;
}

export enum ChromeAppEventType {
	PostMessageSent = 'ChromeApp.PostMessageSent',
	PostMessageResponse = 'ChromeApp.PostMessageResponse',
	PostMessageError = 'ChromeApp.PostMessageError',
}

export enum HTML5EventType {
	PostMessageSent = 'HTML5.PostMessageSent',
	PostMessageReceived = 'HTML5.PostMessageReceived',
}

export enum ShieldSupportabilityEventType {
	LocalResyncAttempt = 'ShieldSupportability.LocalSync',
	ManualNetworkResync = 'ShieldSupportability.ManualNetworkResync',
	CollectLogs = 'ShieldSupportability.CollectLogs',
}

/**
 * All CWA POI launch events share the same `type` and are distinguished by their
 * `code` (see {@link CwaPoiEventCode}).
 */
export enum CwaPoiEventType {
	IcaFileDownload = 'Session.IcaFileDownload',
}

export enum CwaPoiEventCode {
	ClLaunchStart = 'CL-LAUNCH-START',
	IcaDownloadStart = 'ICADOWNLOAD_START',
	IcaDownloadSuccess = 'ICADOWNLOAD_SUCCESS',
	IcaHandoverToCwa = 'ICA-HANDOVER-TO-CWA',
	IcaDownloadError = 'ICADOWNLOAD_ERROR',
}

/**
 * Sent as `action` on CWA POI events; `createCasEvent` maps it onto the inner
 * `payload.type` (the top-level event `type` stays {@link CwaPoiEventType}).
 */
export enum CwaPoiEventAction {
	Start = 'start',
	End = 'end',
	Error = 'error',
}
